import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = { class: "col-12 col-sm-6" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "col-12 col-sm-6" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _ctx.enUrl,
        target: "_blank",
        style: {"color":"unset"}
      }, [
        _createVNode(_component_q_btn, {
          label: "Step by Step Instructions (English)",
          class: "full-width",
          unelevated: "",
          rounded: "",
          outline: "",
          "no-caps": ""
        })
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        href: _ctx.esUrl,
        target: "_blank",
        style: {"color":"unset"}
      }, [
        _createVNode(_component_q_btn, {
          label: "Step by Step Instructions (Spanish)",
          class: "full-width",
          unelevated: "",
          outline: "",
          rounded: "",
          "no-caps": ""
        })
      ], 8, _hoisted_5)
    ])
  ]))
}